module.exports = __webpack_public_path__ + "static/media/ig_2.a45c6cca.jpg";